import Input from '../../../Input/Input';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import { stringScheme } from 'src/utils/validation-schemes';
import { RadioGroup, RadioGroupItem } from 'src/components/ui/radio-group';
import { useGetProjectByIdQuery } from 'src/services';
import { useParams } from 'react-router-dom';
import * as yup from 'yup';

export const IntegrationFormZohoEmail = ({ integration, onSubmit }) => {
  const { id } = useParams();
  const { data: currentProject } = useGetProjectByIdQuery({ id: id }) as any;
  const { watch, handleSubmit, control } = useForm<any>({
    defaultValues: {
      name: integration?.integration_data?.name || '',
      client_id: integration?.integration_data?.client_id || '',
      client_secret: integration?.integration_data?.client_secret || '',
      scope: integration?.integration_data?.scope || 'Desk.tickets.ALL,Desk.basic.READ',
      server_locale: integration?.integration_data?.server_locale || '',
      integration_method: integration?.integration_data?.token ? 'token' : 'code',
      code: integration?.integration_data?.code || '',
      refresh_token: integration?.integration_data?.refresh_token || '',
    },
    resolver: yupResolver(
      yup.lazy((values) => {
        return object({
          name: stringScheme({ required: false }).label('Integration Name'),
          client_id: stringScheme({ required: true }).label('Client ID'),
          client_secret: stringScheme({ required: true }).label('Client secret'),
          scope: stringScheme({ required: true }).label('Scope'),
          server_locale: stringScheme({ required: true }).label('Server locale'),
          code: stringScheme({ required: values.integration_method === 'code' }).label('Code'),
          refresh_token: stringScheme({ required: values.integration_method !== 'code' }).label(
            'Refresh Token',
          ),
        });
      }),
    ),
  });

  const integrationMethod = watch('integration_method');

  const submit = (data) => {
    const result = {
      ...integration,
      integration_data: {
        ...integration.integration_data,
        name: currentProject.name,
        client_id: data.client_id,
        client_secret: data.client_secret,
        scope: data.scope,
        server_locale: data.server_locale,
        code: data.code,
        refresh_token: data.refresh_token,
      },
    };

    if (data.integration_method === 'code') {
      delete result.integration_data.refresh_token;
    } else {
      delete result.integration_data.code;
    }

    onSubmit(result);
  };

  return (
    <form id="integration-form" onSubmit={handleSubmit(submit)}>
      <div className="content">
        <Controller
          control={control}
          name="client_id"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Client ID'}
              placeholder={'7002.3400edkks11ff626343a98234a9ea6ad9'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
            />
          )}
        />
      </div>
      <div className={'content'}>
        <Controller
          control={control}
          name="client_secret"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'password'}
              label={'Client secret'}
              placeholder={'h899001.fhidjkkd.3728dj2664aas3637090211284hdjn5vs3kk220032'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
            />
          )}
        />
      </div>
      <div className="content">
        <Controller
          control={control}
          name="scope"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Scope'}
              placeholder={'Desk.tickets.ALL,Desk.basic.READ'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
            />
          )}
        />
      </div>
      <div className="content">
        <Controller
          control={control}
          name="server_locale"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Server locale'}
              placeholder={'com'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
            />
          )}
        />
      </div>
      <div className={'content'}>
        <Controller
          control={control}
          name="integration_method"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <RadioGroup
              onChange={onChange}
              onValueChange={onChange}
              defaultValue={value}
              className="flex flex-row mt-5 mb-2.5 gap-5"
            >
              <div className={'flex items-center gap-2'}>
                <RadioGroupItem value={'code'} id="code" />
                <label htmlFor="code" className="cursor-pointer">
                  <p className="font-medium text-base text-ebony opacity-70 hover:opacity-100 transition">
                    Code
                  </p>
                </label>
              </div>
              <div className={'flex items-center gap-2'}>
                <RadioGroupItem value={'token'} id="token" />
                <label htmlFor="token" className="cursor-pointer">
                  <p className="font-medium text-base text-ebony opacity-70 hover:opacity-100 transition">
                    Token
                  </p>
                </label>
              </div>
            </RadioGroup>
          )}
        />
      </div>
      {integrationMethod === 'code' && (
        <div className="content">
          <Controller
            control={control}
            name="code"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <Input
                type={'text'}
                label={'Code'}
                placeholder={
                  '1453.1308edkks30cc626343a98234d9ea6ad9.be9736d58da9bamllddbbc8f68a3f4ff00'
                }
                invalidMessage={error?.message}
                value={value}
                isValid={!error?.message}
                onChange={onChange}
              />
            )}
          />
        </div>
      )}
      {integrationMethod === 'token' && (
        <div className="content">
          <Controller
            control={control}
            name="refresh_token"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <Input
                type={'text'}
                label={'Refresh Token'}
                placeholder={
                  '1000.8bfe42342affd5435478dc30b9036009.4239d1aab6e4f32b071224a313068b37'
                }
                invalidMessage={error?.message}
                value={value}
                isValid={!error?.message}
                onChange={onChange}
              />
            )}
          />
        </div>
      )}
    </form>
  );
};
